import confirm from "./confirm";

export default function confirmDelete(cb) {
  confirm(cb, "Are you sure you want to delete this?");
}
